import LinearProgress from '@mui/material/LinearProgress';
import DocumentTableWrapper from '../components/documents/DocumentTableWrapper';
import useSetOrg from '../components/hooks/useSetOrg';
import useUserInfo from '../components/hooks/useUserInfo';
import { DocumentContextProvider } from '../context/DocumentContext';
import { useNavigate, useParams } from 'react-router';
import { useSetTitle } from '../components/hooks/useSetTitle';

interface ParamTypes {
  [key: string]: string | undefined;
  dpid?: string;
}

const DocumentsPage = () => {
  useSetTitle(`Document Manifest`);
  const navigate = useNavigate();
  const { dpid } = useParams<ParamTypes>();

  const { loading } = useSetOrg(dpid);
  const userInfo = useUserInfo();

  if (userInfo.isLoading || loading) {
    return <LinearProgress />;
  }

  return (
    <DocumentContextProvider>
      <DocumentTableWrapper />
    </DocumentContextProvider>
  );
};

export default DocumentsPage;
